module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_1001367.10c62029.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_1001367.pdf
// module id = 351
// module chunks = 0